import {Base,Axios} from "@/api/Base"

export class ReportSendPaymentSlip extends Base {
    //此处修改后台登录用户修改密码的请求路径
    path = "report/sendPaymentSlip"
    
}